/*
 * @Descripttion:
 * @version:
 * @Author: geory
 * @Date: 2023-05-29 17:48:52
 * @LastEditors: geory
 * @LastEditTime: 2026-03-03 11:16:27
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import config from "./config/config";
import http from "./servers/http";
import common from "./common/js/common";
import element from "./element/index";
import toastRegistry from "./components/Toast/index";
import imgCompress from "./common/js/imageCompress";
import "./common/css/element-variables.scss";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer);
//视频预览组件
import IVViewer from "iv-viewer-v2";
Vue.component("iv-viewer", IVViewer);

Vue.config.productionTip = false;
Vue.prototype.$config = config;
Vue.prototype.$http = http;
Vue.prototype.$common = common;
Vue.prototype.$compressImg = imgCompress;

Vue.use(element);
Vue.use(toastRegistry);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
